import { render } from "./AvatarsRow.vue?vue&type=template&id=03a1f5a4&scoped=true&ts=true"
import script from "./AvatarsRow.vue?vue&type=script&lang=ts"
export * from "./AvatarsRow.vue?vue&type=script&lang=ts"

import "./AvatarsRow.vue?vue&type=style&index=0&id=03a1f5a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a1f5a4"]])

export default __exports__